<template>
  <v-dialog
      persistent
      :scrollable="true"
      v-model="showDurationPopup"
      width="600"
      max-width="95%"
      @keydown.esc="close(true)"
      :dark="compColor.isInDarkMode"
      :color="compColor.primeColor"
      overlay-opacity="0.9"
  >
    <div class="elevation-10 layout-column" style="border-radius: 6px;"
         :style="{background: compColor.contentFrame}">

      <!-- HEADER -->

      <div class="text-h6 font-weight-light pa-3 layout-row layout-align-center-center"
           :class="isDarkMode? 'blue-grey--text text--lighten-2' : ' grey--text text--darken-2'">
        <div class="flex"></div>
        <span>{{ $t('BLACKLIST.DIALOG_DURATION.HEADER') }}</span>

        <div class="flex"></div>
        <v-icon class="layout-align-end-end mr-1" @click="close(true)" :color="compColor.primeColor">cancel</v-icon>
      </div>

      <v-divider v-bind:style="{'border-color':compColor.lightDivider}"></v-divider>

      <!-- Content -->

      <div class="ma-1 px-2 py-3 layout-column elevation-3" style="border-radius: 5px;overflow-y:auto;" :style="{'background': compColor.lxExpansion.background}">
        <div class="flex-100 px-2">
          <fake-input-frame :label="$t('BLACKLIST.DIALOG_DURATION.LABEL_RADIO_GROUP') + ' *'">
            <div class="layout-column px-4 pb-3 pt-2 flex">
              <v-radio-group :dense="denseFields" v-model="duration" hide-details
                             class="ma-0 pa-0" style="flex:unset;margin-top: 10px;">
                <v-radio v-for="(value) in durationList"
                         :label="value.text"
                         :value="value.key"
                         :key="value.key"
                         :color="compColor.isInDarkMode ? compColor.primeHighlightColor : compColor.primeColor"
                         class="mb-1"
                         :dark="compColor.isInDarkMode">
                </v-radio>
              </v-radio-group>
            </div>
          </fake-input-frame>
        </div>
      </div>

      <!-- BUTTON -->

      <div class="layout-row layout-align-end-center pa-1">
        <v-btn depressed :color="compColor.prime" :dark="isDarkMode" class="flex white--text text-none mr-1"
               @click="close()">
          {{ $t('buttons.take_over.value') }}
        </v-btn>
        <v-btn depressed color="grey" :dark="isDarkMode" class="white--text text-none" @click="close(true)">
          {{ $t('COMPONENT_REPORT.BUTTON.CANCEL') }}
        </v-btn>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import formsMetaData from '../../components/documentation/shared/formsMetaData'
import utils from '../../common/utils'

export default {
  name: 'PopupBlacklistDuration',
  mixins: [formsMetaData, utils],
  props: {
    showDurationPopup: Boolean
  },
  data () {
    return {
      durationList: [],
      duration: 'E'
    }
  },
  created () {
    this.durationList = this.formsMetaData.blackListDurationList
  },
  methods: {
    /**
     * Close modal of black list duration
     *
     * @param isAborting Value is triggered, if esc-key is pressed
     */
    close (isAborting) {
      if (isAborting) {
        this.$emit('set-show-blacklist-duration-dialog')
        return
      }

      const args = this.returningDateForBlackList(this.duration)

      this.$emit('set-show-blacklist-duration-dialog', args)
    }
  },
  watch: {
    showDurationPopup: {
      handler: function (newValue, oldValue) {
        if (newValue && newValue !== oldValue) {
          this.duration = 'E'
        }
      }
    }
  }
}
</script>
